import React, { useState } from 'react';

import ResultsPerPage from '@Containers/ResultsPagination/ResultsPerPage/ResultsPerPage';
import Pagination from '@Containers/ResultsPagination/Pagination/Pagination';
import PropTypes from 'prop-types';

import './RsPaging.scss';

function RsPaging({
  pageSize = 30,
  currentPage = 0,
  totalPages = 0,
  totalItems,
  pageSizeValues = [15, 30, 45, 60, 75, 90, 100],
  onChange = () => null,
  renderPageSize = true,
}) {
  const [isOpen, setOpen] = useState(false);
  const isGotToPageVisible = totalPages > 5;
  const isPageSizeVisible = renderPageSize && totalItems >= Math.min(...pageSizeValues);
  const pageSizeValuesAdopted = pageSizeValues.map((value) => ({ value, label: value }));
  return (
    <nav className="retro-synthesis-pagination align-items-center u-els-display-flex u-els-margin-top-1x1o2 u-els-margin-bottom-4x u-els-padding-left-2x">
      {isPageSizeVisible && (
        <ResultsPerPage
          resultsPerPage={pageSize}
          setResultsPerPage={(newPageSize) => onChange({ size: newPageSize, currentPage })}
          dropdownOpen={isOpen}
          setDropdownOpen={setOpen}
          dropdownValues={pageSizeValuesAdopted}
        />
      )}
      {currentPage && totalItems && (
        <Pagination
          currentPage={currentPage}
          resultsPerPage={pageSize}
          totalPages={totalPages}
          totalItems={totalItems}
          shouldDisplayGoToPage={isGotToPageVisible}
          onSelect={(number) => onChange({ size: pageSize, page: number - 1 })}
        />
      )}
    </nav>
  );
}

RsPaging.propTypes = {
  pageSize: PropTypes.number,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  totalItems: PropTypes.number,
  pageSizeValues: PropTypes.array,
  onChange: PropTypes.func,
  renderPageSize: PropTypes.bool,
};

export default RsPaging;
